<script lang="ts" setup>
import type { ResponsiveImageType } from "vue-datocms";
import type { ButtonRecord, CustomerCtaSectionRecord } from "~~/server/graphql/datocms/generated";
import { Image as DatocmsImage } from "vue-datocms";

defineProps<{ data: CustomerCtaSectionRecord }>();
</script>

<template>
  <div class="mb-3xl lg:mb-5xl relative mx-auto max-w-[886px]">
    <Vector class="vector--background-light absolute left-[-50px] top-[-70px] z-0 block w-56 rotate-0 lg:hidden" />

    <div class="relative z-10 mx-auto w-full rounded-lg bg-linear-to-b from-[#a7d6e1] to-[#6ebace] shadow-[0px_0px_15px_0px_#a7d6e1]">
      <div class="grid grid-cols-3 items-end">
        <div class="p-lg md:px-3xl md:py-2xl relative col-span-3 overflow-hidden lg:col-span-2">
          <Vector class="vector--background-primary rotate-210 absolute bottom-[-120px] left-16 z-20 h-51 w-48" />

          <div class="relative z-30 flex h-full w-fit flex-col">
            <h4 class="mb-3">
              {{ data.title }}
            </h4>
            <div class="markdown-content text-md xl:text-lg" v-html="data.text" />
            <!-- loop through actions here -->
            <div class="flex flex-col gap-4 sm:flex-row sm:items-center">
              <template v-for="actionLink in data.actionLinks" :key="actionLink.id">
                <div v-if="actionLink.__typename === 'ButtonRecord'">
                  <StructuredButton :data="actionLink as ButtonRecord" size="sm" />
                </div>
                <div v-if="actionLink.__typename === 'CustomLinkRecord'">
                  <NuxtLink :to="actionLink.customLink" class="underline">
                    {{ actionLink.text }}
                  </NuxtLink>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div class="col-span-1 hidden! lg:block!">
          <DatocmsImage
            v-if="data.image"
            :data="data.image!.responsiveImage as ResponsiveImageType"
            :lazy-load="false"
            object-fit="contain" class="h-[290px]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.vector--background-light {
  --esc-vector-fill-color: #f3f1ec;
  --esc-vector-opacity: 1;
  --esc-vector-mix-blend-mode: normal;
}

.vector--background-primary {
  --esc-vector-fill-color: #c5e3eb;
  --esc-vector-opacity: 0.2;
  --esc-vector-mix-blend-mode: normal;
}
</style>
